import i18n from "../../../../../i18n";
import { FIFTH_FLOOR_CD_IMG } from "../../floor_images";
import elevator from "../../elevator_positions";

let fifth_floor_locations;
export default fifth_floor_locations = [
  // {
  //   floor: i18n.t("fifth_floor"),
  //   imageURL: FIFTH_FLOOR_CD_IMG,
  //   title: "501",
  //   marked_position_x: 36,
  //   marked_position_y: 127,
  // },
  {
    floor: i18n.t("fifth_floor"),
    imageURL: FIFTH_FLOOR_CD_IMG,
    ...elevator.library,
    title: "502",
    marked_position_x: 31,
    marked_position_y: 99,
  },
  {
    floor: i18n.t("fifth_floor"),
    imageURL: FIFTH_FLOOR_CD_IMG,
    ...elevator.library,
    title: "503",
    marked_position_x: 55,
    marked_position_y: 93,
  },
  {
    floor: i18n.t("fifth_floor"),
    imageURL: FIFTH_FLOOR_CD_IMG,
    ...elevator.library,
    title: "504",
    marked_position_x: 76,
    marked_position_y: 96,
  },
  // {
  //   floor: i18n.t("fifth_floor"),
  //   imageURL: FIFTH_FLOOR_CD_IMG,
  //   title: "506",
  //   marked_position_x: 95,
  //   marked_position_y: 93,
  // },
  {
    floor: i18n.t("fifth_floor"),
    imageURL: FIFTH_FLOOR_CD_IMG,
    ...elevator.library,
    title: "507",
    marked_position_x: 112,
    marked_position_y: 93,
  },
  {
    floor: i18n.t("fifth_floor"),
    imageURL: FIFTH_FLOOR_CD_IMG,
    ...elevator.library,
    title: "508",
    marked_position_x: 146,
    marked_position_y: 111,
  },
  // {
  //   floor: i18n.t("fifth_floor"),
  //   imageURL: FIFTH_FLOOR_CD_IMG,
  //   title: "510",
  //   marked_position_x: 113,
  //   marked_position_y: 190,
  // },
  // {
  //   floor: i18n.t("fifth_floor"),
  //   imageURL: FIFTH_FLOOR_CD_IMG,
  //   title: "511",
  //   marked_position_x: 75,
  //   marked_position_y: 186,
  // },
  // {
  //   floor: i18n.t("fifth_floor"),
  //   imageURL: FIFTH_FLOOR_CD_IMG,
  //   title: "512" + i18n.t("office_letter_a"),
  //   marked_position_x: 40,
  //   marked_position_y: 199,
  // },
  // {
  //   floor: i18n.t("fifth_floor"),
  //   imageURL: FIFTH_FLOOR_CD_IMG,
  //   title: "513" + i18n.t("office_letter_b"),
  //   marked_position_x: 33,
  //   marked_position_y: 181,
  // },
  // {
  //   floor: i18n.t("fifth_floor"),
  //   imageURL: FIFTH_FLOOR_CD_IMG,
  //   title: "514" + i18n.t("office_letter_a"),
  //   marked_position_x: 33,
  //   marked_position_y: 163,
  // },
  // {
  //   floor: i18n.t("fifth_floor"),
  //   imageURL: FIFTH_FLOOR_CD_IMG,
  //   title: "515",
  //   marked_position_x: 40,
  //   marked_position_y: 145,
  // },
];
